export const LOCALE = 'ru';
